export default "__VITE_PUBLIC_ASSET__898f3997__"